module.exports = __webpack_public_path__ + "img/快手.32b05c65.png";